/**
 * V2 wrapper for Validation tab. Used by ViewDetailV2 (and future TableDetailV2 / MappingDetailV2).
 * @see NewValidation — shared implementation used by Table/Mapping details.
 */
import { NewValidation } from './NewValidation'

export const NewValidationV2 = () => <NewValidation />
